module.exports = __webpack_public_path__ + "img/icon.846e49fc.png";